import React, { useEffect } from "react";
import Loading from "../components/Loading";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { withRouter } from "react-router";
import { useDispatch } from "react-redux";
import { callRemote, GET } from "../service/RemoteService";
import { determineIfTokenError } from "../store/AuthThunks";

export const ProfileComponent = (props) => {
    let dispatch = useDispatch();
    const { user, getAccessTokenSilently } = useAuth0();

    const history = props.history;

    useEffect(() => {
        const checkStripeSetup = async () => {
            try {
                const stripeStatus = await callRemote(getAccessTokenSilently, GET, "/stripe/status");
                if (!stripeStatus.enabled) {
                    const account = await callRemote(getAccessTokenSilently, GET, "/stripe/");
                    const onboardingLink = await callRemote(getAccessTokenSilently, GET, "/stripe/" + account.accountId);
                    window.location = onboardingLink.url
                } else {
                    history.push('/');
                }
            } catch (e) {
                dispatch(determineIfTokenError(e));
            }
        }

        const roles = user != null && user["http://exoticcartrader.com/role"];
        if (roles && roles.includes("Photographer")) {
            checkStripeSetup();
        } else {
            history.push('/');
        }
    }, [user, history, dispatch, getAccessTokenSilently]);

    return (
        <div>
            <Loading/>
        </div>
    );
};

export default withAuthenticationRequired(withRouter(ProfileComponent), {
    onRedirecting: () => <Loading />,
});
